import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-mall-portraits",
  "use": "icon-soc-mall-portraits-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-mall-portraits\">\n<g fill=\"currentColor\">\n  <circle cx=\"512\" cy=\"360\" r=\"160\" />\n  <path d=\"M200 820c40-180 160-260 312-260s272 80 312 260v40H200z\" />\n  <circle cx=\"780\" cy=\"280\" r=\"56\" />\n  <circle cx=\"244\" cy=\"280\" r=\"56\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-mall-portraits.svg
// module id = VnoY
// module chunks = 491